/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoAutorizacaoAliases {
  FRAGMENT_ANEXO_TISS = 'fragment-anexo-tiss',
  FRAGMENT_AUTORIZACAO_DADOS_GUIA = 'fragment-autorizacao-dados-guia',
  PANEL_HISTORICO_AUTORIZACAO = 'panel-historico-autorizacao',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_ANEXOS_TISS = 'tab-with-content-anexos-tiss',
  TAB_WITH_CONTENT_DADOS_GUIA = 'tab-with-content-dados-guia',
}
export { HistoricoAutorizacaoAliases };
